type PageModule = Promise<{ default: React.ComponentType }>;

/** Signed-in pages, each its own chunk. The router lazy-loads them; `preloadAppPages` warms them up. */
export const appPages = {
  dashboard: () => import('@/features/dashboard/pages/DashboardPage'),
  leads: () => import('@/features/leads/pages/LeadsPage'),
  trash: () => import('@/features/leads/pages/TrashPage'),
  leadDetail: () => import('@/features/leads/pages/LeadDetailPage'),
  companies: () => import('@/features/companies/pages/CompaniesPage'),
  users: () => import('@/features/users/pages/UsersPage'),
  account: () => import('@/features/account/pages/AccountPage'),
} satisfies Record<string, () => PageModule>;

/**
 * The data router keeps the old page on screen until the next page's chunk has
 * downloaded. Fetching every chunk up front makes navigation switch pages at once,
 * so the new page shows its skeleton instead of the previous page lingering.
 */
export function preloadAppPages(): Promise<unknown> {
  return Promise.allSettled(Object.values(appPages).map((load) => load()));
}
